/**
 * Geocode an address using the Nominatim (OpenStreetMap) API.
 * Returns { lat, lng, label } or throws on failure.
 */
export const geocodeAddress = async (address, city, country) => {
  const query = [address, city, country].filter(Boolean).join(', ');
  if (!query.trim()) throw new Error('Enter at least address and city first');
  const response = await fetch(
    `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&limit=1`,
    { headers: { 'User-Agent': 'LiveBetterHub/1.0' } }
  );
  if (!response.ok) throw new Error('Geocoding service unavailable');
  const data = await response.json();
  if (!data.length) throw new Error('Address not found — try adding city or country');
  return {
    lat: parseFloat(data[0].lat),
    lng: parseFloat(data[0].lon),
    label: data[0].display_name.split(',').slice(0, 3).join(',').trim(),
  };
};
